// extracted by mini-css-extract-plugin
module.exports = {"box":"View_box_2Mqkq"};